export default {
  primaryLight: '#668fff',
  primary: '#4d7cff',
  primaryDark: '#3369ff',
  primaryIcons: '#b7c9e9',
  primaryText: '#405466',

  secondaryLight: '#f2f7ff',
  secondary: '#d8e6ff',
  secondaryDark: '#bfd7ff',
  secondaryText: '#9ba1ac',

  navigationBgBlue: '#f5f6fa',

  success: '#a3d472',
  info: '#4d7cff',
  warning: '#ffd883',
  error: '#ff4d52',

  highDemand: '#ffae56',
  highDemandSecondary: '#fff0df',
  available: '#46e3cf',
  availableSecondary: '#e8fbf8',
  full: '#ff5461',
  fullSecondary: '#ffeef0',
  offline: '#9381ff',
  offlineSecondary: '#ece9ff',
};



// WEBPACK FOOTER //
// ./src/components/styling/ColorPalette.js